export const checkDecimals = (val: string | number, maxDecimals: number) => {
  if (!val) return true;
  if (isNaN(Number(val))) return false;

  const splitValueDot = Number(val)
    .toLocaleString("en-US", {
      useGrouping: false,
      maximumFractionDigits: 100,
    })
    .split(".");
  // Handle incorrect number
  if (splitValueDot.length > 2) return false;

  const decimals = splitValueDot.length === 1 ? 0 : splitValueDot[1].length;

  return decimals <= maxDecimals;
};
